<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('CargoMsg.Cargo_SignContract')"
    width="600px"
    append-to-body
    class="app-main-inner-row"
    :close-on-click-modal="false"
  >
    <div style="font-size: 16px; color: #4389D0">
      {{ $t('CargoMsg.Cargo_ContractedClientInformation') }}
    </div>
    <div>
      <el-form label-width="85px" label-position="left" style="padding-left: 35px;padding-top: 20px;">
        <el-form-item :label="$t('CargoMsg.Cargo_ChineseNamed')" style="margin-bottom: 0" no="1">
          {{ client.name || '' }}
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_EnglishNamed')" no="2">
          {{ client.englishName || '' }}
        </el-form-item>
        <div v-show="currentState === 'match'">
          <div style="font-size: 16px; color:#4389D0;margin-left:-35px">{{ $t('CargoMsg.Cargo_SignContractTip') }}</div>
          <el-form-item label-width="0">
            <el-radio v-model="joinGroup" :label="1" no="3">{{ $t('CargoMsg.Cargo_SignContractTipYes') }}</el-radio>
          </el-form-item>
          <el-form-item label-width="0">
            <el-radio-group v-model="curCompany" class="companyRadioGroup" :disabled="joinGroup === 0" style="height: 200px;overflow-y: auto">
              <el-radio-button v-for="company in companyList" :key="company.uuid" v-model="curCompany" :label="company.uuid" border no="4">
                <p>{{ company.chineseName }}</p>
                <p>{{ company.englishName }}</p>
              </el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label-width="0">
            <el-radio v-model="joinGroup" :label="0" :disabled="!enabledNoJoin" no="5">{{ $t('CargoMsg.Cargo_SignContractTipNo') }}</el-radio>
          </el-form-item>
          <el-form-item />
        </div>
      </el-form>
    </div>
    <div slot="footer" style="margin:0 auto;width:fit-content">
      <el-button type="primary" no="6" @click="confirmClickHandler">{{ $t('CargoMsg.Cargo_SignContract') }}</el-button>
      <el-button no="7" @click="closeHandler">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { QuotationClient } from '@/class/model/sales/QuotationClient'
import { getMatchCompanyByName, signQuotationClientJoinCompany, signQuotationClientList } from '@/api/sales/quotationClient'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { getLoading } from '@/utils/utilBaseElement'

export default {
  name: 'SignMatchTitleWindow',
  components: { cargoAdvanceSelect },
  props: {
    visible: { type: Boolean, required: true },
    client: { type: Object, required: true }
  },
  data() {
    return {
      joinGroup: 1,
      enabledNoJoin: true,
      innerVisible: false,
      currentState: 'normal',
      companyList: [], // 签单时关联的合作伙伴
      curCompany: ''
    }
  },
  watch: {
    visible: {
      handler(newVal) {
        this.innerVisible = newVal
        if (newVal) this.commitProperties()
      },
      immediate: true
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    commitProperties() {
      if (this.client) {
        this.loading = getLoading()
        this.enabledNoJoin = true

        const conMap = {}
        conMap.name = this.client.name
        conMap.englishName = this.client.englishName
        conMap.branchId = this.$store.getters.currentOfficeId
        getMatchCompanyByName({ conMap }).then(res => this.getMatchCompanyByNameHandler(res)).finally(() => {
          this.loading.close()
        })
      }
    },
    getMatchCompanyByNameHandler(res) {
      this.companyList = res.data
      this.currentState = (this.companyList && this.companyList.length > 0) ? 'match' : 'normal'
      if (this.currentState === 'match') {
        this.curCompany = this.companyList[0].uuid
        for (const company of this.companyList) {
          if (!this.enabledNoJoin) continue
          this.enabledNoJoin = !(this.client.name === company['chineseName'] || this.client.englishName === company['englishName'])
        }
      }
    },
    // 签单
    confirmClickHandler() {
      this.loading = getLoading()
      const conMap = {}
      if (this.currentState === 'match' && this.joinGroup === 1) {
        // QuotationClient.signQuotationClientJoinCompany(client,preSelectItem.item["uuid"],signQuotationClientHandler,faultHandler);
        conMap.clientUuid = this.client.uuid
        conMap.companyUuid = this.curCompany
        // 签单-关联合作伙伴
        signQuotationClientJoinCompany({ conMap }).then(res => this.signQuotationClientHandler(res)).finally(() => {
          this.loading.close()
        })
      } else {
        // QuotationClient.signQuotationClientList(new ArrayCollection([client]),signQuotationClientHandler,faultHandler);
        // 签单
        const clientUuids = [this.client.uuid]
        signQuotationClientList(clientUuids).then(res => this.signQuotationClientHandler(res)).finally(() => {
          this.loading.close()
        })
      }
    },
    // 签单成功
    async signQuotationClientHandler(res) {
      if (this.loading) this.loading.close()
      const item = res.data
      if (item && item.msg) {
        await this.$confirm(item['msg'], this.$t('FileHistory.Tips'), { type: 'warning' }).finally(() => {
          this.loading.close()
        })
      } else if (item === 1) {
        this.$message.warning(this.$t('Message.TheOrThePartnerSigned'))
      } else {
        this.$message.success(this.$t('CargoMsg.Cargo_ContractSignedSuccessfully'))
        this.$emit('signSuccessCallBack')
      }
      this.closeHandler()
    },
    closeHandler() {
      this.innerVisible = false
    },
    onClear(val) {
      this.toEmail = ''
    }
  }
}
</script>

<style lang="scss">
.companyRadioGroup{
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-left: 20px;
  .el-radio-button {
    width: 100%;
    &__inner {
      display: block;
      width: 100%;
      border-radius: 4px!important;
      border:1px solid #DCDFE6!important;
      text-align: left;
      margin-bottom: 10px;
      box-shadow:none!important;
      p {
        margin: 0;
        &:nth-child(1){
          margin-bottom: 10px;
        }
      }
    }
  }
}
</style>
